import { rgba } from 'polished';
import styled from 'styled-components';

import { cFF005C } from '#/colors';

export const Error = styled.div.attrs({ role: 'alert' })`
  background-color: ${rgba(cFF005C, 0.1)};
  border-radius: 7px;
  border: 1px solid ${rgba(cFF005C, 0.5)};
  color: #ffffff;
  font-size: 11px;
  line-height: 16px;
  font-weight: 500;
  padding: 10px 10px 10px 18px;
  position: relative;
  width: 100%;
  min-width: 0px;
  word-break: break-word;

  &:before {
    content: '';
    position: absolute;
    left: 5px;
    top: 5px;
    height: calc(100% - 10px);
    width: 5.4px;
    border-radius: 2.5px;
    background-color: ${cFF005C};
  }
`;
